import React from "react"

import PaymentOptionsPicker from "../../components/payment-options-picker"
import { useSession } from "../session-context"
import { StepProps } from "../step-registry"

const PaymentOptionsPickerStep: React.FC<StepProps> = ({ onComplete, onBack }) => {
  const { sessionData, updateProduct, updateProgress } = useSession()

  const handleInstallmentSelect = (installments?: number) => {
    updateProduct({ preSelectedInstallment: installments })
  }

  const handlePaymentOptionsComplete = () => {
    updateProgress({ paymentOptionsCompleted: true })
    updateProgress({ startedSignupFlow: true })
    onComplete()
  }

  return (
    <PaymentOptionsPicker
      calculatedPrices={sessionData.product.calculatedPrices}
      onInstallmentSelected={handleInstallmentSelect}
      onContinue={handlePaymentOptionsComplete}
      onBack={onBack}
      preSelectedInstallment={sessionData.product.preSelectedInstallment}
    />
  )
}

export default PaymentOptionsPickerStep
